import ATableAccess from "./aTableAccess";

class LocalBookingStorageAccess extends ATableAccess {}

export default LocalBookingStorageAccess;
